const claimButtonsConfig = formatMessage => {
  return [
    {
      children: formatMessage({ id: 'REOPEN', defaultMessage: 'Reopen' }),
      type: 'submit',
      variant: 'contained',
      color: 'warning',
      value: 'REOPEN',
    },
    {
      children: formatMessage({
        id: 'APPROVE_OVERRIDE',
        defaultMessage: 'Approve Override',
      }),
      type: 'submit',
      variant: 'contained',
      color: 'success',
      value: 'APPROVE_OVERRIDE',
    },
    {
      children: formatMessage({
        id: 'REJECT_OVERRIDE',
        defaultMessage: 'Reject Override',
      }),
      type: 'submit',
      variant: 'contained',
      color: 'error',
      value: 'REJECT_OVERRIDE',
    },
    {
      type: 'divider',
    },
    {
      children: formatMessage({ id: 'REJECT', defaultMessage: 'Reject' }),
      type: 'submit',
      variant: 'contained',
      color: 'error',
      value: 'REJECT',
    },
    {
      children: formatMessage({ id: 'APPROVE', defaultMessage: 'Approve' }),
      type: 'submit',
      variant: 'contained',
      color: 'success',
      value: 'APPROVE',
    },
    {
      children: formatMessage({ id: 'SUBMIT', defaultMessage: 'Submit' }),
      type: 'submit',
      variant: 'contained',
      color: 'success',
      value: 'SUBMIT',
    },
    {
      children: formatMessage({
        id: 'CANCEL_CLAIM',
        defaultMessage: 'Cancel Claim',
      }),
      type: 'submit',
      variant: 'contained',
      color: 'secondary',
      value: 'CANCEL',
    },
    {
      type: 'divider',
    },
    {
      children: formatMessage({ id: 'CREATE', defaultMessage: 'Create' }),
      type: 'submit',
      variant: 'contained',
      color: 'primary',
      claimStatuses: [],
      value: 'CREATE',
      align: 'right',
    },
    {
      children: formatMessage({ id: 'UPDATE', defaultMessage: 'Update' }),
      type: 'submit',
      variant: 'contained',
      color: 'primary',
      value: 'UPDATE',
      align: 'right',
    },
  ];
};

export default claimButtonsConfig;
